import React, { useCallback, useEffect, useMemo, useState } from "react";
import { TeacherAppProps, ValueTokenTeacher } from "./TeacherApp.model";

export const TokenTeacher = React.createContext<ValueTokenTeacher>({
  token: null,
  updateToken: () => {},
});

const TeacherApp = (props: TeacherAppProps) => {
  const [token, setToken] = useState<string | null>(
    localStorage.getItem("token")
  );

  const updateToken = useCallback(
    (tokenParam: string | null) => {
      if (tokenParam === null) {
        localStorage.removeItem("token");
      } else {
        localStorage.setItem("token", tokenParam);
      }
      setToken(tokenParam);
    },
    [setToken]
  );

  useEffect(() => {
    const id = setInterval(() => {
      const tokenFromStorage = localStorage.getItem("token");
      updateToken(tokenFromStorage);
    }, 1000);
    return () => {
      clearInterval(id);
    };
  }, [updateToken]);
  return (
    <TokenTeacher.Provider
      value={{
        token,
        updateToken,
      }}
    >
      {props.children}
    </TokenTeacher.Provider>
  );
};

export { TeacherApp };
